export default "/assets/favicon_blue.svg";